module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "employeeConfig"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-collapse', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "操作面板",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "t-op__container"
  }, [_c('div', {
    staticClass: "t-op__item"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "t-op__item"
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请输入客户姓名"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.loadData
    },
    slot: "append"
  })], 1)], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "width": "100%",
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "80",
      "label": "序号",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "show-overflow-tooltip": "",
      "width": "260",
      "label": "客户名称",
      "prop": "customer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建人",
      "prop": "createBy",
      "formatter": _vm.fmtUserId
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建时间",
      "prop": "createTime",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "修改人",
      "prop": "modifyBy",
      "formatter": _vm.fmtUserId
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "修改时间",
      "prop": "modifyTime",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改\n                        ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "padding": "10px 0px"
    },
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "hide-on-single-page": _vm.value,
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "current-page": _vm.pageIndex
    },
    on: {
      "current-change": _vm.onCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editItem.title,
      "width": _vm.editItem.width,
      "visible": _vm.editItem.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editItem, "visible", $event)
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editItem.data
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.editItem.data.customer),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "customer", $$v)
      },
      expression: "editItem.data.customer"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editItem.visible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e663178"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/customer/customerManage.vue
// module id = 615
// module chunks = 1